import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../i18n";
import "./AuthButton.css";

const AuthButton = () => {
    const { instance, accounts } = useMsal();
    const navigate = useNavigate();
    const { t } = useI18n();

    const handleLogin = async () => {
        try {
            // Vérifier si une interaction est en cours
            if (instance.getAllAccounts().length > 0) {
                console.log("Utilisateur déjà connecté");
                navigate("/pdfgenerator");
                return;
            }

            // Vérifier et nettoyer les interactions en cours
            if (instance.getActiveAccount()) {
                await instance.clearCache();
                instance.setActiveAccount(null);
            }

            // Tenter la connexion
            await instance.loginPopup(loginRequest);
            navigate("/pdfgenerator");
        } catch (e) {
            if (e.errorCode === "interaction_in_progress") {
                console.warn("Une interaction est déjà en cours. Tentative de nettoyage...");
                try {
                    await instance.acquireTokenSilent(loginRequest);
                    navigate("/pdfgenerator");
                } catch (silentError) {
                    console.error("Échec de l'acquisition silencieuse du token:", silentError);
                }
            } else {
                console.error("Erreur de connexion:", e);
            }
        }
    };

    const handleLogout = async () => {
        try {
            // Nettoyer le cache avant la déconnexion
            await instance.clearCache();
            await instance.logoutPopup({
                mainWindowRedirectUri: window.location.origin,
            });
            navigate("/");
        } catch (e) {
            console.error("Erreur de déconnexion:", e);
        }
    };

    return (
        <div className="auth-container">
            {accounts.length > 0 ? (
                <button onClick={handleLogout} className="logout-button">
                    {t("logout")}
                </button>
            ) : (
                <button onClick={handleLogin} className="login-button">
                    {t("login")}
                </button>
            )}
        </div>
    );
};

export default AuthButton;